// এই ফাইলটা তখন কাজে লাগে যখন backend (Laravel) থেকে কোনো event/post/team
// member/testimonial-এর জন্য এখনো কোনো ছবি upload করা হয়নি। প্লেইন ধূসর
// SVG icon না দেখিয়ে, আমরা থিমভিত্তিক সুন্দর local photo-এর একটা pool থেকে
// item-টার id/slug অনুযায়ী নির্দিষ্ট একটা ছবি বেছে দেখাই — একই item বারবার
// একই ছবি পাবে (consistent), কিন্তু আলাদা item আলাদা ছবি পাবে (varied)।

import EventOneImg1 from "../assets/images/resources/event-one-img-1.jpg";
import EventTwoImg1 from "../assets/images/resources/event-two-img-1.jpg";
import EventTwoImg2 from "../assets/images/resources/event-two-img-2.jpg";
import ConferenceImg1 from "../assets/images/resources/conference-one-img-1.jpg";
import ConferenceImg2 from "../assets/images/resources/conference-one-img-2.jpg";
import ConferenceImg3 from "../assets/images/resources/conference-one-img-3.jpg";
import ConferenceImg4 from "../assets/images/resources/conference-one-img-4.jpg";
import ConferenceImg5 from "../assets/images/resources/conference-one-img-5.jpg";
import EventDetailsImg1 from "../assets/images/resources/event-details-img-1.jpg";

import BlogImg1 from "../assets/images/blog/blog-1-1.jpg";
import BlogImg2 from "../assets/images/blog/blog-1-2.jpg";
import BlogImg3 from "../assets/images/blog/blog-1-3.jpg";
import BlogImg4 from "../assets/images/blog/blog-1-4.jpg";
import BlogImg5 from "../assets/images/blog/blog-1-5.jpg";
import BlogImg6 from "../assets/images/blog/blog-1-6.jpg";
import BlogImg7 from "../assets/images/blog/blog-2-1.jpg";
import BlogImg8 from "../assets/images/blog/blog-2-2.jpg";
import BlogImg9 from "../assets/images/blog/blog-2-3.jpg";

import TeamImg1 from "../assets/images/team/team-1-1.jpg";
import TeamImg2 from "../assets/images/team/team-1-2.jpg";
import TeamImg3 from "../assets/images/team/team-1-3.jpg";
import TeamImg4 from "../assets/images/team/team-1-4.jpg";
import TeamImg5 from "../assets/images/team/team-1-5.jpg";
import TeamImg6 from "../assets/images/team/team-1-6.jpg";

import TestimonialImg1 from "../assets/images/testimonial/testimonial-one-client-1-1.jpg";
import TestimonialImg2 from "../assets/images/testimonial/testimonial-one-client-1-2.jpg";
import TestimonialImg3 from "../assets/images/testimonial/testimonial-one-client-1-3.jpg";
import TestimonialImg4 from "../assets/images/testimonial/testimonial-one-client-1-4.jpg";
import TestimonialImg5 from "../assets/images/testimonial/testimonial-one-client-1-5.jpg";
import TestimonialImg6 from "../assets/images/testimonial/testimonial-one-client-1-6.jpg";

import GalleryImg1 from "../assets/images/gallery/gallery-1-1.jpg";
import GalleryImg2 from "../assets/images/gallery/gallery-1-2.jpg";
import GalleryImg3 from "../assets/images/gallery/gallery-1-3.jpg";
import GalleryImg4 from "../assets/images/gallery/gallery-1-4.jpg";

export const EVENT_IMAGE_POOL = [
  EventOneImg1,
  EventTwoImg1,
  EventTwoImg2,
  ConferenceImg1,
  ConferenceImg2,
  ConferenceImg3,
  ConferenceImg4,
  ConferenceImg5,
  EventDetailsImg1,
  GalleryImg1,
  GalleryImg2,
  GalleryImg3,
  GalleryImg4,
];

export const BLOG_IMAGE_POOL = [
  BlogImg1,
  BlogImg2,
  BlogImg3,
  BlogImg4,
  BlogImg5,
  BlogImg6,
  BlogImg7,
  BlogImg8,
  BlogImg9,
];

export const TEAM_IMAGE_POOL = [
  TeamImg1,
  TeamImg2,
  TeamImg3,
  TeamImg4,
  TeamImg5,
  TeamImg6,
];

export const TESTIMONIAL_IMAGE_POOL = [
  TestimonialImg1,
  TestimonialImg2,
  TestimonialImg3,
  TestimonialImg4,
  TestimonialImg5,
  TestimonialImg6,
];

// একটা string/number seed (id, slug, title ইত্যাদি) থেকে deterministic ভাবে
// pool-এর একটা ছবি বেছে নেয়, যাতে একই item সবসময় একই ছবি পায়।
export function pickPoolImage(pool, seed) {
  if (!pool || pool.length === 0) return null;
  const str = String(seed ?? Math.random());
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return pool[hash % pool.length];
}
